//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The quality of the media file. */
export const MediaElementQuality = {
    /** Any other file type not already defined. */
    Other: 0,

    /** An audio file that contains no video. */
    Audio: 1,

    /**
     * The URL is actually an i-frame embed URL that will be
     * used to play the video.
     */
    Embed: 2,

    /** Standard Definition video is defined as below 720p. */
    SD: 3,

    /** High Definition video is defined as 720p or higher. */
    HD: 4,

    /** Ultra High Definition video is defined as 4K or higher. */
    UltraHD: 5,

    /**
     * HTTP Live Streaming quality, this is for m3u8 streams that adapt
     * to the user's available bandwidth to show the best quality
     * available.
     */
    HLS: 6
} as const;

/** The quality of the media file. */
export const MediaElementQualityDescription: Record<number, string> = {
    0: "Other",

    1: "Audio",

    2: "Embed",

    3: "Standard Definition",

    4: "High Definition",

    5: "Ultra High Definition",

    6: "HLS"
};

/** The quality of the media file. */
export type MediaElementQuality = typeof MediaElementQuality[keyof typeof MediaElementQuality];
